// @flow
import MeetDetail from './MeetDetail';
export default MeetDetail;



// WEBPACK FOOTER //
// ./src/scenes/Meets/components/MeetDetail/index.js